import React from 'react';
import './city-pic.style.sass';
import {Button} from "rsuite";
import {Link} from "react-router-dom";

const CityPic = () => {
    return (
        <div className='city-pic'>
            <div className='pic-area'>
                <div className='pic-text'>
                    <h4>ویژگی های منحصر به فرد <span><strong>زیتونیکس</strong></span></h4>
                    <Link to='/specialFeatures'><Button appearance="ghost">اطلاعات بیشتر</Button></Link>
                </div>
            </div>
        </div>
    );
};

export default CityPic;